import { ReactNode } from 'react';
import { Flex, FlexProps } from '@blockanalitica/ui';

export interface FancyTextProps extends FlexProps {
  children: ReactNode;
}

export default function FancyText({ children, ...rest }: FancyTextProps) {
  return (
    <Flex {...rest} name="fancyText">
      {children}
    </Flex>
  );
}
